import { render, staticRenderFns } from "./page008.vue?vue&type=template&id=03348371&scoped=true&"
import script from "./page008.vue?vue&type=script&lang=js&"
export * from "./page008.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03348371",
  null
  
)

export default component.exports